import React from 'react';
import { Dropdown as AntDropdown, DropDownProps as AntDropdownProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface DropdownProps extends AntDropdownProps {}

const useStyles = createUseStyles((theme: ThemeType) => ({
  dropdown: {
    '& .ant-dropdown-menu': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
      padding: theme.spacing[1],
      borderRadius: theme.radius.sm,
      boxShadow: theme.shadow.md,
    },
    '& .ant-dropdown-menu-item': {
      color: theme.color.semantic.text.primary,
      fontSize: `${theme.typography.fontSize.sm} !important`,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
      '&:active, &:focus': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
      '&.ant-dropdown-menu-item-disabled': {
        color: theme.color.semantic.text.subtle,
        cursor: 'not-allowed',
      },
    },
    '& .ant-dropdown-menu-submenu-title': {
      color: theme.color.semantic.text.primary,
      fontSize: `${theme.typography.fontSize.sm} !important`,
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
    },
  },
  dropdownButton: {
    '& .ant-btn': {
      backgroundColor: theme.color.semantic.brand.default.subtle,
      color: `${theme.color.semantic.brand.default.secondary} !important`,
      borderColor: `${theme.color.semantic.brand.default.secondary} !important`,
      borderRadius: theme.radius.sm,
      '&:hover': {
        backgroundColor: `${theme.color.semantic.brand.default.muted} !important`,
        color: `${theme.color.semantic.brand.default.secondary} !important`,
        borderColor: `${theme.color.semantic.brand.default.secondary} !important`,
      },
      '&:active, &:focus': {
        backgroundColor: `${theme.color.semantic.brand.default.light} !important`,
        color: `${theme.color.semantic.brand.default.primary} !important`,
        borderColor: `${theme.color.semantic.brand.default.primary} !important`,
      },
    },
  },
}));

const DropdownInner: React.FC<DropdownProps> = ({ overlayClassName = '', ...rest }) => {
  const classes = useStyles();
  return (
    <AntDropdown
      {...rest}
      overlayClassName={`${classes.dropdown} ${overlayClassName}`.trim()}
    />
  );
};

const DropdownButton: React.FC<any> = ({ className = '', overlayClassName = '', ...props }) => {
  const classes = useStyles();
  return (
    <AntDropdown.Button
      {...props}
      className={`${classes.dropdownButton} ${className}`.trim()}
      overlayClassName={`${classes.dropdown} ${overlayClassName}`.trim()}
    />
  );
};

const Dropdown = Object.assign(DropdownInner, {
  Button: DropdownButton,
});

export default Dropdown;
